<template>
  <a href="#" class="link" @click="changeClient">
    {{ item.title }}
  </a>
</template>

<script>
import auth from '@/auth'

export default {
  name: 'AppListSwitchClientTitle',

  props: {
    item: Object,
  },

  methods: {
    changeClient() {
      let item = this.item
      auth.switchClient(item._id, () => {
        this.$router.push({ name: 'entities' })
      })
    },
  },
}
</script>
